import BaseApiService from "./BaseApiService";

const _userListing = (page,pageSize) => {
  return BaseApiService.get(`/api/v1/users?page=${page}&pagesize=${pageSize}`, null, null);
};

const _userByFilters = (payload) => {
  return BaseApiService.post(`/api/v1/users/filters`, null, payload);
};

const _updateUser = (phone,payload) => {
  return BaseApiService.put(`/api/v1/users/${phone}`, null, payload);
};

const _userDetails = (phone) => {
  return BaseApiService.get(`/api/v1/users/${phone}`, null, null);
};

const _userConversation = (phone, page, pagesize = 10,filter = "all") => {
  return BaseApiService.get(
    `/api/v1/users/${phone}/messages?page=${page}&pagesize=${pagesize}&time_filter=${filter}`,
    null,
    null
  );
};

const _resetFlow = (
  phone,
  code = process.env.REACT_APP_ON_MESSAGE_API_CODE
) => {
  return BaseApiService.request(
    "DELETE",
    `/api/v1/users/reset/${phone}?code=${code}`,
    null,
    null,
    {},
    {},
    {},
    false,
    true
  );
};

const _userScheduleMessage =(phone)=>{
  return BaseApiService.get(`/api/v1/scheduled_messages/${phone}`,null,null);
}

export const UserApiService = {
  userListing: _userListing,
  updateUser:_updateUser,
  userByFilters:_userByFilters,
  userDetails: _userDetails,
  userConversation: _userConversation,
  resetFlow: _resetFlow,
  userScheduleMessage:_userScheduleMessage
};
